<div class="block-item" [class.unpublished]="!block.is_published">
  <div class="block-controls">
    <button mat-icon-button (click)="moveDown.emit()" [disabled]="isLast" class="arrow-btn"
            matTooltip="Klicke hier um den Inhalt nach unten zu verschieben.">
      <mat-icon>arrow_downward</mat-icon>
    </button>
    <button mat-icon-button (click)="moveUp.emit()" [disabled]="isFirst" class="arrow-btn"
            matTooltip="Klicke hier um den Inhalt nach oben zu verschieben.">
      <mat-icon>arrow_upward</mat-icon>
    </button>
    <span class="block-label">{{ blockLabel }}</span>
    <button mat-icon-button (click)="edit.emit()"
            matTooltip="Klicke hier um den Inhalt zu bearbeiten.">
      <mat-icon>edit</mat-icon>
    </button>
    @if (!isStandard) {
      <button mat-icon-button color="accent" (click)="remove.emit()" class="delete-btn"
              matTooltip="Klicke hier um den Inhalt zu löschen.">
        <mat-icon>delete</mat-icon>
      </button>
    }
    <button mat-icon-button class="collapsible-btn"
            [class.collapsible-active]="block.is_collapsible"
            (click)="toggleCollapsible.emit()"
            [matTooltip]="collapsibleTooltip">
      <mat-icon>{{ block.is_collapsible ? 'unfold_less' : 'unfold_more' }}</mat-icon>
    </button>
    <mat-slide-toggle [checked]="block.is_published" (change)="togglePublish.emit()" color="primary"
                      [matTooltip]="toggleTooltip"></mat-slide-toggle>
  </div>

  <div class="block-preview">
    @switch (block.block_type.name) {
      @case ('logo') {
        @if (block.logo_path || localLogoUrl) {
          @if (!hasImageError(block.logo_path)) {
            <img [src]="localLogoUrl || getMediaUrl(block.logo_path)"
                 class="preview-thumb logo-thumb" alt="Logo"
                 (error)="onImageError(block.logo_path, $event)">
          } @else {
            <div class="preview-image-error" [matTooltip]="imageErrorFor(block.logo_path)?.url || ''">
              <mat-icon>broken_image</mat-icon>
              <span>Bild konnte nicht geladen werden</span>
            </div>
          }
        }
      }
      @case ('address') {
        <p class="preview-text">{{ block.street }}<br>{{ block.postal_code }} {{ block.city }}</p>
      }
      @case ('phone') {
        <p class="preview-text">{{ block.phone }}</p>
      }
      @case ('website') {
        <p class="preview-text">{{ block.website }}</p>
      }
      @case ('text') {
        @if (block.title) { <p class="preview-title">{{ block.title }}</p> }
        @if (block.body_text) { <p class="preview-text">{{ block.body_text }}</p> }
      }
      @case ('video') {
        @if (block.title) { <p class="preview-title">{{ block.title }}</p> }
        @if (block.video_preview_path) {
          @if (!hasImageError(block.video_preview_path)) {
            <img [src]="getMediaUrl(block.video_preview_path)"
                 class="preview-thumb" alt="Video-Vorschau"
                 (error)="onImageError(block.video_preview_path, $event)">
          } @else {
            <div class="preview-image-error" [matTooltip]="imageErrorFor(block.video_preview_path)?.url || ''">
              <mat-icon>broken_image</mat-icon>
              <span>Vorschau konnte nicht geladen werden</span>
            </div>
          }
        }
      }
      @case ('image') {
        @if (block.title) { <p class="preview-title">{{ block.title }}</p> }
        @if (block.image_path) {
          @if (!hasImageError(block.image_path)) {
            <img [src]="getMediaUrl(block.image_path)"
                 class="preview-thumb" alt="Bild"
                 (error)="onImageError(block.image_path, $event)">
          } @else {
            <div class="preview-image-error" [matTooltip]="imageErrorFor(block.image_path)?.url || ''">
              <mat-icon>broken_image</mat-icon>
              <span>Bild konnte nicht geladen werden</span>
            </div>
          }
        }
      }
      @case ('button') {
        <p class="preview-text">{{ block.button_text }}</p>
      }
      @case ('contact_person') {
        <p class="preview-title">{{ block.contact_name }}</p>
        @if (block.contact_function) { <p class="preview-text">{{ block.contact_function }}</p> }
        @if (block.contact_area) { <p class="preview-text">{{ block.contact_area_custom || block.contact_area }}</p> }
      }
    }
  </div>
</div>
